import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgLiveagent = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 10a2 2 0 0 1-1.105 1.789 3.002 3.002 0 0 1-2.641 2.2A8.003 8.003 0 0 1 4.582 12H4a2 2 0 0 1-2-1.999V8a2 2 0 0 1 2-2h.582a8.003 8.003 0 0 1 14.837 0H20a2 2 0 0 1 2 2v2ZM6 9a6 6 0 1 1 11.197 3H13a1 1 0 1 0 0 2h2.318A6 6 0 0 1 6 9Z"
      fill={color}
    />
    <path
      d="M3.97 23.242A4.28 4.28 0 0 1 8.123 20h7.754a4.28 4.28 0 0 1 4.153 3.242l1.94-.485A6.28 6.28 0 0 0 15.877 18H8.123a6.28 6.28 0 0 0-6.093 4.758l1.94.485Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLiveagent);
export default ForwardRef;
